module.exports = __webpack_public_path__ + "static/media/Left legs14.3705b0ba.png";